import { createSlice } from "@reduxjs/toolkit";

interface RootState {
    loading:boolean

}

const initialState: RootState = {
    loading: true,
};

export const imageSlice :any = createSlice({
  name: "image",
  initialState,
  reducers: {
    setBacisImages: (state: any, { payload }) => {
      state.loading = payload;
    },
  },
  
});

export const {setBacisImages} = imageSlice.actions;

export const getImageDetails = (state: any) => state.imageReducer.loading;



export default imageSlice.reducer;
